import Vue from 'vue';
import { HTTP_GRAYLOG } from '../http';

export default {
  search(params) {
    return HTTP_GRAYLOG.get('/api/search/universal/absolute', {
      params,
      auth: {
        username: `${Vue.prototype.$runtimeConfig.VUE_APP_GRAYLOG_TOKEN}`,
        password: 'token',
      },
    }).then(response => response.data);
  },
  searchRelative(params) {
    return HTTP_GRAYLOG.get('/api/search/universal/relative', {
      params,
      auth: {
        username: `${Vue.prototype.$runtimeConfig.VUE_APP_GRAYLOG_TOKEN}`,
        password: 'token',
      },
    }).then(response => response.data);
  },
  searchMailsInvalids() {
    return HTTP_GRAYLOG.post(`/api/views/search/${Vue.prototype.$runtimeConfig.VUE_APP_GRAYLOG_SEARCH_MAIL_ID}/execute`, {}, {
      auth: {
        username: `${Vue.prototype.$runtimeConfig.VUE_APP_GRAYLOG_TOKEN}`,
        password: 'token',
      },
      headers: {
        'X-Requested-By': 'edocperso-admin',
      },
    }).then(response => response.data);
  },
};
